import React, { useEffect, useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Form,
  Button,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { isEmpty } from 'lodash';
import Logo from 'components/Logo';
import poweredBy from 'assets/images/powered_by_pharmaforce.svg';
import useOidc from 'hooks/useOidc';
import useAxios from 'hooks/useAxios';
import user from "assets/icon/user-icon.svg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Export from "assets/icon/ExportDownloads.svg";
import DownLoadingPending from "assets/icon/ExportDownloads.svg";
import DownLoadingCompleted from "assets/icon/ExportDownloadComplete.svg";
import ExportCancel from "assets/icon/ExportCancelIcon.svg";
import useSignalr from "hooks/useSignalr";
import moment from "moment";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Loader from "components/Loader";
import ExportPending from "assets/icon/ExportPending.svg";



const Header = () => {
  const { logout } = useOidc();
  const [isOpen, setOpen] = useState(false);
  const signalR = useSignalr();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [hidePoweredBy, setHidePoweredBy] = useState(false);
  const [userName, setUserName] = useState('');
  const[isChecked,setIsChecked] =useState(false);
  const [downloadHistory, setDownloadHistory] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const API = useAxios();


  useEffect(() => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const interval = setInterval(() => { }, 1000);
    const { username } = profile || {};
    setUserName(username);
    const theme = sessionStorage.getItem('theme') || "PF";

    if (theme === "PF") setHidePoweredBy(true);

    if (!access_token) {
      navigate('/');
    }
    return () => {
      clearInterval(interval);
    };
  }, []);
const handeLocalChange=(event)=>{
  const checked=event.target.checked;
setIsChecked(checked);
sessionStorage.setItem("changeport",checked)
window.location.reload(true)
}
useEffect(()=>{
  const storedState=sessionStorage.getItem("changeport")==='true';
  setIsChecked(storedState)
},[])

  const handleLogout = () => {
    sessionStorage.clear();
    logout();
  };
  
  useEffect(() => {
    
    if (signalR.count >= 1) {
      setIsLoading(true);

      // if (signalR && signalR.messages && signalR.messages.length > 0) {
      // }
    } else {
      setIsLoading(false);
    }
  }, [signalR.messages, signalR.count, isLoading]);
  useEffect(() => {
    if (signalR.messages.length !== 0) {
      setDropdownOpen(true);
    }
  }, [signalR.messages]);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleModal = () => setOpen(!isOpen);

  const handelToggle = () => {
    setLoading(true);
    getDownloadHistory();
    setOpen(!isOpen);
  };

  const handleDownloadHistory = (event) => {
    
    event.preventDefault();
    event.stopPropagation();
    getDownloadHistory();
  };

  const getDownloadHistory = async () => {
    setLoading(true);
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_MESSAGE_ENDPOINT}/api/Download/DownloadHistory/CPReportUI`,
        {
          // params: { Id: sub },
          headers: {
            "Content-type": "application/json",
            Authorization: `${token_type} ${access_token}`,
          },
        }
      );
      setLoading(true);

      if (data) {
        
        setOpen(!isOpen);

        // console.log("Data:", data);

        data.map((item, index) => {
          // console.log("Processing item:", item);

          if (Array.isArray(item.dataExportMessages)) {
            item.dataExportMessages.map((item1, index) => {
              // console.log("Processing item1:", item1);
              item1.gridCode = AppModuleName(item1.gridCode);
            });
          }
        });
        setDownloadHistory(data);
        setLoading(false);
      }
    } catch (ex) { }
  };

  const download = async (dataExportId) => {
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    window.open(
      `${process.env.REACT_APP_MESSAGE_ENDPOINT}/api/Download/Download/${dataExportId}?access_token=${access_token}`
    );
  };

  const AppModuleName = (gridCode) => {
    let moduleName = "";
    if (gridCode.indexOf("pharmacy") !== -1) {
      moduleName = "Pharmacy Report";
    } 
    return moduleName;
  }

  return (
    <>
   
      <Navbar color='white' light className='app-header'>
      <div className="d-flex align-items-center">
          <NavbarBrand href="/" className="me-0">
            <Logo height={50} />
          </NavbarBrand>
          <h2 className="ps-3 ms-3 text-primary d-inline mx-1 mt-1 mb-0 top_hed">
            Contract Pharmacy 2.0
          </h2>
        </div>
        <div className='ms-auto powered-by'>
          <img src={poweredBy} title='' alt='' hidden={hidePoweredBy} />
        </div>

        {(
          <Nav className='nav_info'>
            {/* <UncontrolledDropdown nav className='profile-dropdown'>
              <DropdownToggle nav caret className='font-weight-500'>
                {userName}
              </DropdownToggle>
              <DropdownMenu className='shadow'>
                <DropdownItem onClick={handleLogout}>Logout</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown> */}
            <UncontrolledDropdown
                nav
                className="profile-dropdown"
                isOpen={dropdownOpen}
                toggle={toggleDropdown}
              >
                <DropdownToggle
                  nav
                  className=""
                  style={{ position: "relative" }}
                >
                  <OverlayTrigger
                    overlay={(props) => (
                      <Tooltip {...props}>Export Notifications</Tooltip>
                    )}
                    placement="bottom"
                  >
                    {/* <img src={Export} alt="" /> */}
                    {/* {isLoading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        style={{
                          position: "absolute",
                          top: "80%",
                          left: "-20%",
                          // transform: "translate(-50%, -50%)",
                        }}
                      />
                    ) : (
                      <img src={Export} alt="Export" />
                    )} */}
                    {isLoading ? (
                      <div className="spinner-container">
                        {/* <Spinner
                          animation="border"
                          size="sm"
                          className="spinner-overlay"
                        /> */}
                        <img
                          src={Export}
                          alt="Export"
                          className="export-image"
                        />
                      </div>
                    ) : (
                      <img src={Export} alt="Export" className="export-image" />
                    )}
                  </OverlayTrigger>
                </DropdownToggle>
                <DropdownMenu className="shadow export">
                  <DropdownItem>
                    <div>
                      <div
                        className="d-flex justify-content-between "
                        style={{ borderBottom: "1px solid #D3D3D3" }}
                      >
                        <span
                          className="f-12"
                          style={{ fontWeight: 500, color: "#757575" }}
                        >
                          Export Notifications
                        </span>
                        <div>
                          <a
                            onClick={(event) => {
                              handleDownloadHistory(event);
                            }}
                            className="text-primary f-12 font-weight-600"
                            style={{ color: "" }}
                          >
                            View All
                          </a>
                        </div>
                      </div>
                      <>
                        {signalR.count == 1 && (
                          <div>
                             <div className="d-flex mt-2">
                              <img src={ExportPending} />
                              <div className="f-16 font-weight-600 ms-2 word-wrap">
                                <div className="text-left">
                                  {" "}
                                  Downloading is in progress. We will notify you when it is complete.
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </> 
                      <>
                        {signalR.count != 1 && signalR.messages.length !== 0 && (
                          <div>
                            <div className="mt-2">
                              <div className=" d-flex justify-content-between ms-2">
                                <div>
                                  <div className="f-16 font-weight-600 text-primary">
                                    {signalR.messages.fileName}
                                  </div>
                                  <div
                                    className="f-12 font-weight-500"
                                    style={{ color: "#757575" }}
                                  >
                                    {AppModuleName(signalR.messages.gridCode)}
                                  </div>
                                </div>
                                <div
                                  className=" d-flex justify-content-end w-100 h-auto"
                                  style={{
                                    overflow: "auto",
                                    wordWrap: "break-word",
                                  }}
                                >
                                  <div
                                    className="f-12 font-weight-500"
                                    style={{
                                      color: "#757575",
                                    }}
                                  >
                                    <p
                                      style={{
                                        whiteSpace: "pre-wrap",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {moment(
                                        new Date(
                                          signalR.messages.fileGeneatedDate
                                        )
                                      ).format("MM/DD/YYYY")}
                                    </p>
                                    <p
                                      style={{
                                        whiteSpace: "pre-wrap",
                                        marginBottom: "0px",
                                      }}
                                    >
                                      {moment(
                                        new Date(
                                          signalR.messages.fileGeneatedDate
                                        )
                                      ).format("hh:mm A")}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="">
                              <Button
                                color="primary"
                                className="search mt-2 w-100"
                                onClick={() =>
                                  download(signalR.messages.dataExportID)
                                }
                              >
                                <span className="right_5">
                                  <img src={DownLoadingCompleted} alt="" />
                                </span>
                                Download
                              </Button>
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
               <UncontrolledDropdown nav className="profile-dropdown">
                <DropdownToggle nav className="">
                  <OverlayTrigger
                    overlay={(props) => (
                      <Tooltip {...props}>View Profile</Tooltip>
                    )}
                    placement="bottom"
                  >
                    {/* <FontAwesomeIcon icon={faUser} className="fa-fw text-dark topicons" style={{ width: '25px', height: '25px' }} /> */}

                    <img src={user} alt="" />
                  </OverlayTrigger>
                </DropdownToggle>
                <DropdownMenu className="shadow">
                  <DropdownItem>
                    <div id="app">
                      <div className="text-end">
                        <div
                          className="text-start"
                          style={{ marginLeft: "0px", zIndex: 9999999 }}
                        >
                          <div className="">
                            <div
                              id="circle-avatar"
                              className="text-center mx-auto mb-4 h3"
                            >
                              {userName[0]}
                            </div>

                            <h5 className="text-center" style={{ whiteSpace: "normal" }}>{userName}</h5>
                            {/* <p className="text-center mb-2">jd@gmail.com</p> */}

                            {/* <hr /> */}

                            {/* <hr className="mb-0" style={{ margin: "0 -24px 0" }} /> */}

                            <div
                              className="list-group list-group-flush"
                            // style={{ margin: "0 -24px 0" }}
                            >
                              <button className="list-group-item list-group-item-action">
                                <small>Change Requests</small>
                              </button>
                              <button className="list-group-item list-group-item-action ">
                                <small>Pending Requests</small>
                              </button>
                              <button className="list-group-item list-group-item-action">
                                <small>Other Requests</small>
                              </button>
                            </div>

                            {/* <hr style={{ margin: "0 -24px 24px" }} /> */}

                            <div className="d-grid">
                              <button
                                className="btn btn-secondary"
                                onClick={handleLogout}
                              >
                                <small>Logout</small>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
          </Nav>
        )}
        <Modal
          isOpen={isOpen}
          toggle={handelToggle}
          size="lg"
          className="lg "
        >
          <ModalBody className="m-2 p-4">
            <div className="d-flex justify-content-between">
              <h6 className="f-24 ">All Exports</h6>
              <div onClick={handelToggle}>
                <img src={ExportCancel} />
              </div>
            </div>
            {loading == true ? (
              <Loader opacity={0.01} color="black" />
            ) : (
              <div className="export-modal">
                {downloadHistory.map((item, index) => (
                  <Row className="mt-3  ">
                    <h6
                      className="f-14 font-size-600"
                      style={{ color: "#757575" }}
                    >
                      {item.displayHeader}
                    </h6>
                    <hr></hr>
                    {item.dataExportMessages.map((item1, index) => (
                      <Col md={6} className="mt-2">
                        <div
                          className="p-2"
                          style={{
                            border: "1px solid #D3D3D3",
                            borderRadius: "4px",
                            minHeight:"100px",
                          }}
                        >
                          <div className=" d-flex justify-content-between align-items-center"
                          style={{
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                          }}
                          >
                            <div className="f-14 font-weight-600 text-primary">
                              {item1.fileName}
                            </div>
                            <div
                              className="f-12 font-weight-500"
                              style={{ color: "#757575" }}
                            >
                              {moment(new Date(item1.fileGeneatedDate)).format(
                                "MM/DD/YYYY hh:mm A"
                              )}
                            </div>
                          </div>
                          <div
                            className=" d-flex justify-content-between mt-2"
                          style={{
                            alignItems:"flex-end",
                          }}
                          >
                            <div
                              className="f-12 font-weight-500"
                              style={{
                                color: "#757575",
                              }}
                            >
                              {item1.gridCode}
                            </div>
                            {/* <div className="">
                              <Button
                                color="primary"
                                className="search-downlaod"
                                onClick={() => download(item1.dataExportID)}
                              >
                                {" "}
                                <span className="right_5">
                                  <img src={DownLoadingPending} alt="" />
                                </span>{" "}
                                Download
                              </Button>
                            </div> */}
                            {item1.exportStatusID == 1 ? (
                              <div className="">
                                <Button
                                  color="primary"
                                  className="search"
                                  onClick={() => download(item1.dataExportID)}
                                >
                                  {" "}
                                  <div className="spinner-container1">

                                  </div>

                                  {"  "}  In Progress
                                </Button>
                              </div>
                            ) : (
                              <div className="">
                                <Button
                                  color="primary"
                                  className="search-downlaod"
                                  onClick={() => download(item1.dataExportID)}
                                >
                                  {" "}
                                  <span className="right_5">
                                    <img src={DownLoadingPending} alt="" />
                                  </span>{" "}
                                  Download
                                </Button>
                              </div>
                            )}

                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                ))}
              </div>
            )}

            {/* {
                downloadHistory.map((item, index) => (
                  <Col md={6}>
                    <div
                      className="p-2"
                      style={{ border: "1px solid #D3D3D3", borderRadius: "4px" }}
                    >
                      <div className=" d-flex justify-content-between align-items-center">
                        <div className="f-16 font-weight-600 text-primary">
                          {item.fileName}
                        </div>
                        <div
                          className="f-12 font-weight-500"
                          style={{ color: "#757575" }}
                        >
                          {moment(new Date(item.fileGeneatedDate)).format("MM/DD/YYYY hh:mm A")}
                        </div>
                      </div>
                      <div
                        className=" d-flex justify-content-between align-items-center"
                      // style={{
                      //   overflow: "auto", // Corrected the typo here
                      //   wordWrap: "break-word",
                      // }}
                      >
                        <div
                          className="f-12 font-weight-500"
                          style={{
                            color: "#757575",
                          }}
                        >
                          {item.gridCode}
                        </div>
                        <div className="">
                          <Button color="primary" className="search " onClick={() => download(item.dataExportID)}>
                            {" "}
                            <span className="right_5">
                              <img src={DownLoadingPending} alt="" />
                            </span>{" "}
                            Download
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              } */}
          </ModalBody>
        </Modal>
 
      </Navbar>
    </>
  );
};

export default Header;
